import { Modal } from 'reactstrap';

const PendingBalanceInfoModal = ({
  isOpen,
  toggle
}) => {
  return (
    <Modal
      isOpen={isOpen}
      centered
      className="cm_g_modal_wrapper"
    >
      <div className='cm_g_modal_header'>
        <h3>Balance Information</h3>
        <span onClick={toggle}>
          <i className='fa-solid fa-xmark'></i>
        </span>
      </div>

      <div className='cm_g_modal_body'>
        <div className='cm_inner_modal_scroll_div'>
          <div className='d-flex gap-3'>
            <div>
              <span className='bg_icon_g'>
                <i className='fa-solid fa-info'></i>
              </span>
            </div>
            <div className='w-full'>
              <p>Your available balance is ready to withdraw. Your pending balance is still processing.</p>
              <p>You can withdraw via direct deposit or cryptocurrency. Some regions may be limited to cryptocurrency withdrawals only.</p>
            </div>
          </div>

          <div className='bb_card'>
            <h4>Rolling Basis Explained</h4>
            <p>Earnings move from pending to available on a 14-day rolling basis. For example, earnings from the 1st become available on the 15th, earnings from the 2nd on the 16th and so on.</p>
          </div>

          <div className="mb-4">
            <div className="d-flex align-items-center gap-3">
              <div className="gray_dot"></div>
              <div className='w-full'>
                <p>Jan 1st earnings → Available Jan 15th</p>
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="gray_dot"></div>
              <div className='w-full'>
                <p>Jan 2nd earnings → Available Jan 16th</p>
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="gray_dot"></div>
              <div className='w-full'>
                <p>A flat $15 fee is charged on withdrawals over $100 to cover ACH and cryptocurrency transfer fees</p>
              </div>
            </div>
          </div>
        </div>
        <span
          onClick={toggle}
          className='btn btn_primary w-full mt-3'
        >
          Got it
        </span>
      </div>
    </Modal>
  );
};

export default PendingBalanceInfoModal;

